
import { Component, Vue, Watch } from 'vue-property-decorator';
import NevronSearch from "@/components/NevronSearch.vue";
import PerPageDropdown from "@/components/PerPageDropdown.vue";
import vPagination from "@/components/VuePlainPagination.vue";
import SuperAdminPage from "@/components/partials/super-admin-page.vue";
import Filters from "./Filter.vue";
import stores from "../../../stores";
import _ from "lodash";
import moment from 'moment';
import LogDetails from "./Show.vue";
@Component({
  components: {
    Filters,
    SuperAdminPage,
    vPagination,
    PerPageDropdown,
    NevronSearch,
    LogDetails
  },
})
export default class ActivityLog extends Vue {
  response: any = null;
  appliedFilters: any = {};
  filtersQuery: string | undefined = undefined;
  perpage = 20;
  search = { query: '', current: '' };
  searchItems = _.debounce(() => this.fetchData(1), 400);

  get pageReady() {
    return this.response && this.response.data;
  }

  get logs(): IActivityLog[] {
    return this.response?.data || [];
  }

  get filters() {
    return {
      users: { label: 'Users', type: 'select', values: [] },
      tenants: { label: 'Tenants', type: 'select', values: [] },
      events: { label: 'Events', type: 'checkbox', values: ['created', 'updated', 'deleted'] },
    };
  }

  @Watch('response.currentPage')
  changedPage() {
    this.fetchData(this.response.currentPage);
  }

  mounted() {
    this.fetchData(1);
  }

  fetchData(page = 1) {
    stores.ActivityLog.fetchData(page, this.search.query, this.perpage, this.filtersQuery)
      .then((res) => {
        this.search.current = this.search.query;
        this.response = res.data;
      })
      .catch(console.error);
  }

  @Watch('appliedFilters', { deep: true })
  generateFiltersQuery() {
    // Use FiltersClass for static method
    this.filtersQuery = Filters.generateFilterQuery(this.appliedFilters);
    this.fetchData(1);
  }

  updateFilters(newFilters: any) {
    this.appliedFilters = { ...this.appliedFilters, ...newFilters };
  }

  clearFilters() {
    this.appliedFilters = {};
    this.filtersQuery = undefined;
    this.fetchData(1);
  }

  formatDate(date: string) {
    return moment(date).format('DD MMM, YYYY HH:mm');
  }
}
